<template>
  <v-row class="ma-0">
    <v-col class="page-header elevation-1 white">
      <h1 class="text-center my-sm-3 text-big-title text-sm-huge-title text-md-massive-title"><slot></slot></h1>
    </v-col>
  </v-row>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
  h1 {
    margin: 6px 0;
  }
</style>